import { Injectable, Optional, Inject } from '@angular/core';
import { API_ENDPOINT } from '../providers';
import { BmEnvironments } from '../interfaces';
import { noProviderError } from '../../shared/exceptions';

@Injectable()

export class EnvironmentManager {

  constructor(@Optional() @Inject(API_ENDPOINT) private readonly endpoints: BmEnvironments) {

    if (this.endpoints === null) {
      noProviderError('API_ENDPOINT');
    }
  }

  public get environments(): string[] {
    return Object.keys(this.endpoints);
  }

  public get currentEnvironment(): any {
    return this.endpoints[this.currentEnvironmentKey];
  }

  public get currentEnvironmentKey(): any {
    return localStorage.getItem('environment');
  }

  public getEnvironment(key: string): any {
    return this.endpoints[key] || null;
  }

  public setEnvironment(env: string): void {
    if (env in this.endpoints) {
      localStorage.setItem('environment', env);
    }
  }

  public switchEnvironment() {
    const currentEnvIndex = this.environments.indexOf(this.currentEnvironmentKey);
    localStorage.setItem('environment',
      this.endpoints[currentEnvIndex + 1 % this.environments.length]
    );
  }
}
